import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './cases.routes';
import List from './list';
import View from './view';
import Vendor from './vendor';
import New from './new';
import Fill from './fill';
import NewSubCase from './newSubCase';
import FillSubCase from './fillSubCase';
import AuthorizationForm from './authorization-form';
import BulkUpload from './bulkUpload';

export default angular
  .module('verifyApp.cases', [
    uiRouter, List, View, Vendor, New, Fill, AuthorizationForm,
    NewSubCase, FillSubCase, BulkUpload,
  ])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/index.js